import type { LoginInput, LoginResponse, SessionUser } from '@qualibot/shared';
import { api } from './api-client';

export async function login(input: LoginInput): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/api/auth/login', input);
  return data;
}

export async function me(): Promise<SessionUser> {
  const { data } = await api.get<{ user: SessionUser }>('/api/auth/me');
  return data.user;
}

export async function logout(): Promise<void> {
  await api.post('/api/auth/logout');
}
